<ng-form>
  <fieldset>
    <cap-form-row column-classes="col-md-4,col px-0 input-series">
      <cap-form-control [labelKey]="label" invalidKey="EingabeMussValiderTagSein" placeholderKey="DatumTagEingabeFormatBeispiel">
        <input
          (blur)="onTouched()"
          (ngModelChange)="model && (model.tag = $event)"
          [attr.aria-label]="label + 'Tag' | translate"
          [ngModel]="model && model.tag"
          class="text-end teildatum-tag"
          name="geburtsdatum.tag"
          type="text" />
      </cap-form-control>
      <cap-form-control invalidKey="EingabeMussValiderMonatSein" placeholderKey="DatumMonatEingabeFormatBeispiel">
        <input
          (blur)="onTouched()"
          (ngModelChange)="model && (model.monat = $event)"
          [attr.aria-label]="label + 'Monat' | translate"
          [ngModel]="model && model.monat"
          class="text-end teildatum-monat"
          name="geburtsdatum.monat"
          type="text" />
      </cap-form-control>
      <cap-form-control
        column-classes="col-md-4,col ps-0 input-series"
        invalidKey="EingabeMussValidesJahrSein"
        placeholderKey="DatumJahrEingabeFormatBeispiel">
        <input
          (blur)="onTouched()"
          (ngModelChange)="model && (model.jahr = $event)"
          [attr.aria-label]="label + 'Jahr' | translate"
          [ngModel]="model && model.jahr"
          class="text-end teildatum-jahr"
          name="geburtsdatum.jahr"
          type="text" />
      </cap-form-control>
    </cap-form-row>
  </fieldset>
</ng-form>
